import script from "./addChanneToContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./addChanneToContent.vue?vue&type=script&setup=true&lang=ts"

import "./addChanneToContent.vue?vue&type=style&index=0&id=39346442&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39346442"]])

export default __exports__